import { render } from "./GoCardlessPaymentMethod.vue?vue&type=template&id=2e4aabcc"
import script from "./GoCardlessPaymentMethod.vue?vue&type=script&lang=js"
export * from "./GoCardlessPaymentMethod.vue?vue&type=script&lang=js"

import "./GoCardlessPaymentMethod.vue?vue&type=style&index=0&id=2e4aabcc&lang=less"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__